import React, { forwardRef } from "react";
import { Form } from "react-bootstrap";

export interface TextInputProps
  extends Omit<React.ComponentProps<typeof Form.Control>, "ref"> {
  label?: string;
  isRequired?: boolean;
  groupProps?: React.ComponentProps<typeof Form.Group>;
  labelProps?: React.ComponentProps<typeof Form.Label>;
  error?: string;
}

const SwitchInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      label,
      isRequired = false,
      groupProps = {},
      labelProps = {},
      error,
      ...controlProps
    },
    ref
  ) => {
    const { controlId, className = "", ...otherGroupProps } = groupProps;
    return (
      <>
        <Form.Group
          controlId={controlId}
          {...otherGroupProps}
          className={`switch ${className}`}
        >
          {label && (
            <Form.Label {...labelProps}>
              {label} {isRequired && <span style={{ color: "red" }}>*</span>}
            </Form.Label>
          )}
          <div className={`${controlProps.containerClass ?? ""}`}>
            <Form.Control type="checkbox" ref={ref} {...controlProps} />
          </div>
        </Form.Group>
        {error && (
          <span
            style={{ height: "20px", fontSize: "13px" }}
            className="text-danger mt-1"
          >
            {error}
          </span>
        )}
      </>
    );
  }
);

SwitchInput.displayName = "SwitchInput";
export default SwitchInput;
